import { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios";
import DashboardHeader from "../../components/DashboardHeader";

import { IconButton } from "@mui/material";
import DescriptionIcon from '@mui/icons-material/Description';
import Tooltip from '@mui/material/Tooltip';


//TABS - ANT DESIGN
import { Tabs } from "antd";

import TransactionList from "../accounting/TransactionList";
import CustomerView, { initials, formatDate } from "./CustomerView";
import MessageList from "./MessageList";
import { getMediaUrl } from "../../utils/getMediaUrl";
import './Crm.css';

import UserAlerts from "../../components/UserAlerts";

const { TabPane } = Tabs;


const Customer = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState('');
    const errorRef = useRef(null);

    const customerId = params.id


    const [removeBorder, setRemoveBorder] = useState(true);
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data

        },
    });

    const { data: transactions } = useQuery({
        queryKey: ['customer-statement', page],
        queryFn: async () => {
          const response = await authAxios.get(`/accounting/customer-ledger/?customer=${params.id}&page=${page}`);
          setPageCount(response.data.page_count)
          return response.data.results
        },
    });

    const { data: customer } = useQuery({
        queryKey: ['customer',customerId],
        queryFn: async () => {
          const response = await authAxios.get(`crm/customers/${customerId}`);
          return response.data
        },
    });

    //CALC STATS
    // let sumInvoices = 0
    // let sumReceipts = 0
    // let balance = 0

    const joined = formatDate(customer?.created_at, 'MMM yyyy');
    const headerMeta = [
        customer?.customer_id,
        joined && `Joined ${joined}`,
    ].filter(Boolean);

    //Tabs
    const [key, setKey] = useState('overview');
    const handleTabChange = (k) => {
        setKey(k)
    };

    // PAGINATION
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    return (
        <div className="dashboard-main">
            {customer &&

            <section className="dashboard-content dashboard-content-compact co-shell">
                 <div ref={errorRef}>
                    <UserAlerts error={error} />
                </div>

                <div className="dashboard-content-header-nav co-shell-header">
                    <div className="co-avatar">
                        {customer.profile_photo
                            ? <img src={getMediaUrl(customer.profile_photo)} alt={customer.name} />
                            : initials(customer.name)
                        }
                    </div>
                    <div>
                        <DashboardHeader dashboardTitle={customer.name} dashboardPreTitle="Customer" removeBorder={removeBorder} />
                        {headerMeta.length > 0 &&
                            <div className="co-header-meta">{headerMeta.join(' · ')}</div>
                        }
                    </div>
                    <div className="dashboard-content-header-nav-icons">
                        <Tooltip title="Statement">
                            <IconButton 
                                onClick={() => navigate('/dashboard/statement/',{state:{reference:params.id}})}
                            > 
                                <DescriptionIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>


              
                {/* destroyInactiveTabPane preserves the react-bootstrap
                    unmountOnExit behaviour panes rely on (MessageList resets
                    its page state and refetches on return). Lazy first mount
                    and "no pane animation" are AntD defaults. */}
                <Tabs
                    activeKey={key}
                    onChange={handleTabChange}
                    className="co-tabs"
                    destroyInactiveTabPane
                    >
                    
                    <TabPane tab="Overview" key="overview">
                        <CustomerView
                            customer={customer}
                            setError={setError}
                        />
                    </TabPane>

                    <TabPane tab="Ledger" key="statement">
                        {clientProfile &&
                        <div className="dashboard-content-subheader">
                            <div className='dashboard-card'>
                                <div className="dashboard-card-pretitle">
                                    Debits
                                </div>
                                <div className="dashboard-card-text">
                                    {clientProfile.currency_code} {Number(customer.total_debits).toLocaleString()}
                                </div>
                            </div>
                            <div className='dashboard-card'>
                                <div className="dashboard-card-pretitle">
                                    Credits
                                </div>
                                <div className="dashboard-card-text">
                                    {clientProfile.currency_code} {Number(customer.total_credits).toLocaleString()}
                                </div>
                            </div>
                            <div className='dashboard-card'>
                                <div className="dashboard-card-pretitle">
                                    Balance
                                </div>
                                <div className="dashboard-card-text">
                                    {clientProfile.currency_code} {customer.balance.toLocaleString()}
                                </div>
                            </div>

                        </div>
                        }
                        <TransactionList 
                            module="CRM" 
                            transactions={transactions} 
                            handlePageChange={handlePageChange} 
                            page={page} 
                            pagecount={pagecount}
                        />
                    </TabPane>
                    <TabPane tab="Messages" key="messages">
                        <MessageList
                            customer={customer}
                        />
                    </TabPane>
                </Tabs>
            </section>
            }
        </div>
    );
  };
  
  export default Customer;